import { Cuepoint } from "../../types/player-api";

export const skipSegment = (
  onSeekTo: (seek: number) => void,
  duration?: number,
  cuepoint?: Cuepoint
): void => {
  if (cuepoint?.end_time) {
    onSeekTo(cuepoint.end_time);
  } else if (duration) {
    onSeekTo(duration);
  }
};
